import React, { useState } from 'react';
import * as Yup from 'yup';
import {
  Form as BaseForm,
  TextField,
  SubmitButton,
  CancelPopupButton,
} from '../../../../ui/FormElement';
import { useContext } from '../Context';

export default function Form() {
  const FormSchema = Yup.object().shape({
    company: Yup.string().required('Company is required'),
    firstName: Yup.string().required('First Name is required'),
    lastName: Yup.string().required('Last Name is required'),
    email: Yup.string().required('Email is required'),
    website: Yup.string().required('Website is required'),
    phone: Yup.string().required('Phone is required'),
  });

  const [loader, setLoader] = useState(false);

  const { dispatch, state, actions } = useContext();

  const formData = {
    company: state.currentProspect.attributes.company,
    website: state.currentProspect.attributes.website,
    firstName: state.currentProspect.attributes.first_name,
    lastName: state.currentProspect.attributes.last_name,
    email: state.currentProspect.attributes.email,
    phone: state.currentProspect.attributes.phone,
    jobTitle: state.currentProspect.attributes.jobtitle,
  };

  const onSubmit = (values, { setSubmitting, setErrors }) => {
    setSubmitting(false);
    setLoader(true);

    actions.save(
      dispatch,
      state.currentProspect.id,
      values,
      () => {
        setLoader(false);
        actions.hideModal(dispatch);
      },
      (errorData) => {
        const newErrors = {};
        errorData.errors.forEach((item) => {
          newErrors[item.source.pointer.replace('/data/attributes/', '')] = item.detail;
        });
        setErrors(newErrors);
        setLoader(false);
      },
    );
  };

  return (
    <BaseForm
      enableReinitialize
      validationSchema={FormSchema}
      initialValues={formData}
      onSubmit={onSubmit}
    >
      <TextField
        name="company"
        label={(
          <>
            <span>Company</span>
            <abbr title="required">*</abbr>
          </>
        )}
      />

      <TextField
        name="website"
        label={(
          <>
            <span>Website</span>
            <abbr title="required">*</abbr>
          </>
        )}
      />

      <TextField
        name="firstName"
        label={(
          <>
            <span>First Name</span>
            <abbr title="required">*</abbr>
          </>
        )}
      />

      <TextField
        name="lastName"
        label={(
          <>
            <span>Last Name</span>
            <abbr title="required">*</abbr>
          </>
        )}
      />

      <TextField
        name="email"
        label={(
          <>
            <span>Email</span>
            <abbr title="required">*</abbr>
          </>
        )}
      />

      <TextField
        name="phone"
        label={(
          <>
            <span>Phone</span>
            <abbr title="required">*</abbr>
          </>
        )}
      />

      <TextField
        name="jobTitle"
        label={(
          <span>Role</span>
        )}
      />

      <div className="text-center mt50 mb30">
        <CancelPopupButton
          className="btn btn-primary btn-outline mr5 ml5 width-120"
          title="Cancel"
          onClick={() => actions.hideModal(dispatch)}
        />
        <SubmitButton
          title={loader ? 'Please, wait ...' : 'Send'}
          className={`btn width-120 btn-primary submit-button mr5 ml5 ${
            loader ? 'not-possible-click' : ''
          }`}
        />
      </div>
    </BaseForm>
  );
}
